<template>
  <div class="print-pay-fee-beilin-container">
    <!-- 标题 -->
    <div class="receipt-title">西安碑林物业管理有限公司收款收据</div>

    <!-- 头部信息 -->
    <div class="receipt-header">
      <div class="header-row receipt-num-row">
        <div class="header-item right">
          <span class="label">缴费单号：</span>
          <span class="value">{{ printPayFeeInfo.receiptNum }}</span>
        </div>
      </div>
      <div class="header-row">
        <div class="header-item">
          <span class="label">小区：</span>
          <span class="value">{{ printPayFeeInfo.communityName }}</span>
        </div>
        <div class="header-item">
          <span class="label">房号：</span>
          <span class="value">{{ printPayFeeInfo.roomName }}</span>
        </div>
        <div class="header-item">
          <span class="label">业主：</span>
          <span class="value">{{ printPayFeeInfo.payObjName }}</span>
        </div>
        <div class="header-item right">
          <span class="label">收费员：</span>
          <span class="value">{{ printPayFeeInfo.userName }}</span>
        </div>
      </div>
    </div>

    <!-- 费用明细表 -->
    <table class="fee-table">
      <thead>
        <tr>
          <th style="width: 14%;">收费项目</th>
          <th style="width: 24%;">说明</th>
          <th style="width: 10%;">面积</th>
          <th style="width: 10%;">数量（月数）</th>
          <th style="width: 12%;">单价</th>
          <th style="width: 14%;">本期金额</th>
          <th style="width: 16%;">备注</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in printPayFeeInfo.fees" :key="index">
          <td>{{ item.feeName }}</td>
          <td>
            <div v-if="item.preDegrees">
              {{ dateFormat(item.startTime) }} 至 {{ dateFormat(item.endTime) }}<br />
              起止读数：{{ item.preDegrees }} 至 {{ item.curDegrees }}
            </div>
            <div v-else-if="item.feeTypeCd == '888800010006'">-</div>
            <div v-else>
              {{ dateFormat(item.startTime) }} 至 {{ dateFormat(item.endTime) }}
            </div>
          </td>
          <td>{{ item.area || '-' }}</td>
          <td>{{ item.cycle || '-' }}</td>
          <td>{{ formatPrice(item.squarePrice) }}</td>
          <td>{{ item.amount }}</td>
          <td>{{ item.remark || '' }}</td>
        </tr>
      </tbody>
    </table>

    <!-- 合计 -->
    <div class="amount-row">
      <span class="label">金额合计：</span>
      <span class="value">{{ changeNumMoneyToChinese(printPayFeeInfo.amount) }}</span>
      <span class="label">（小写）¥</span>
      <span class="value">{{ printPayFeeInfo.amount }}</span>
    </div>

    <!-- 底部信息 -->
    <div class="receipt-footer">
      <div class="footer-row">
        <div class="footer-item">
          <span class="label">交款人：</span>
          <span class="value">{{ printPayFeeInfo.payObjName }}</span>
        </div>
        <div class="footer-item right">
          <span class="label">打印时间：</span>
          <span class="value">{{ printPayFeeInfo.printTime }}</span>
        </div>
      </div>
      <div class="footer-note">收费票据 盖章有效</div>
    </div>

    <!-- 打印按钮 -->
    <el-row id="print-btn" style="margin-top: 30px;">
      <el-col :span="24" class="text-right">
        <el-button type="primary" @click="handlePrint">
          <i class="fa fa-check"></i>&nbsp;打印
        </el-button>
        <el-button type="warning" style="margin-right:20px;" @click="handleClose">
          取消
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getCommunityId, getCommunityName } from '@/api/community/communityApi'
import { queryFeeReceipt, queryFeeReceiptDetail, queryFeeDetailDiscount } from '@/api/fee/printPayFeeApi'
import { getUserName } from '@/api/user/userApi'
import { dateFormat as formatDate, getDateStr } from '@/utils/dateUtil'
import { changeNumMoneyToChinese } from '@/utils/moneyUtil'

export default {
  name: 'PrintPayFeeBeiLin',
  data() {
    return {
      printPayFeeInfo: {
        communityName: '',
        receiptId: '',
        receiptIds: '',
        detailIds: '',
        merge: '',
        roomName: '',
        receiptNum: '',
        amount: 0.00,
        fees: [],
        feeTime: '',
        payObjName: '',
        feeReceipt: [],
        userName: '',
        printTime: ''
      },
      communityId: ''
    }
  },
  computed: {},
  created() {
    console.log('printPayFeeBeiLin created')
    this.communityId = getCommunityId()
    this.printPayFeeInfo.userName = getUserName()
    this.printPayFeeInfo.printTime = getDateStr()
    this.initData()
  },
  methods: {
    initData() {
      this.printPayFeeInfo.receiptId = this.$route.query.receiptId
      this.printPayFeeInfo.receiptIds = this.$route.query.receiptIds
      this.printPayFeeInfo.detailIds = this.$route.query.detailIds
      this.printPayFeeInfo.merge = this.$route.query.merge
      this.printPayFeeInfo.communityName = getCommunityName()
      console.log('initData, receiptId:', this.printPayFeeInfo.receiptId)
      this.loadReceipt()
    },
    loadReceipt() {
      const params = {
        page: 1,
        row: 30,
        receiptId: this.printPayFeeInfo.receiptId,
        receiptIds: this.printPayFeeInfo.receiptIds,
        detailIds: this.printPayFeeInfo.detailIds,
        communityId: this.communityId
      }
      console.log('loadReceipt params:', params)

      queryFeeReceipt(params).then(response => {
        const feeReceipt = response.data
        console.log('feeReceipt:', feeReceipt)
        let amount = 0
        feeReceipt.forEach(item => {
          amount += parseFloat(item.amount || 0)
        })

        this.printPayFeeInfo.amount = amount.toFixed(2)
        if (feeReceipt.length > 0) {
          this.printPayFeeInfo.roomName = this.trimRoomName(feeReceipt[0].roomName || feeReceipt[0].objName)
          this.printPayFeeInfo.payObjName = feeReceipt[0].payObjName
          this.printPayFeeInfo.feeTime = feeReceipt[0].createTime
          this.printPayFeeInfo.receiptNum = feeReceipt[0].receiptCode || ''
        }
        this.printPayFeeInfo.feeReceipt = feeReceipt
        this.loadReceiptDetail()
      }).catch(error => {
        console.error('查询收据失败', error)
      })
    },
    loadReceiptDetail() {
      const params = {
        page: 1,
        row: 100,
        receiptId: this.printPayFeeInfo.receiptId,
        receiptIds: this.printPayFeeInfo.receiptIds,
        detailIds: this.printPayFeeInfo.detailIds,
        communityId: this.communityId,
        mergeFee: this.printPayFeeInfo.merge
      }
      console.log('loadReceiptDetail params:', params)

      queryFeeReceiptDetail(params).then(response => {
        const feeReceiptDetails = response.data
        console.log('feeReceiptDetails:', feeReceiptDetails)

        feeReceiptDetails.forEach(item => {
          this.printPayFeeInfo.feeReceipt.forEach(im => {
            if (item.receiptId == im.receiptId) {
              item.objName = im.objName
              item.feeTypeCd = im.feeTypeCd
            }
          })
          this.loadFeeDetailDiscount(item.detailId, item)
        })
        this.printPayFeeInfo.fees = feeReceiptDetails
        console.log('fees set:', this.printPayFeeInfo.fees)
      }).catch(error => {
        console.error('查询收据详情失败', error)
      })
    },
    loadFeeDetailDiscount(detailId, item) {
      const params = {
        page: 1,
        row: 100,
        detailId: detailId
      }

      queryFeeDetailDiscount(params).then(response => {
        const feeReceiptDetails = response.data
        if (feeReceiptDetails && feeReceiptDetails.length > 0) {
          feeReceiptDetails.forEach(data => {
            if (data.discountType == '2002') {
              item.discountPrice = parseFloat(data.discountPrice) * -1
            } else {
              item.discountPrice = 0
            }
          })
        } else {
          item.discountPrice = 0
        }
      }).catch(error => {
        console.error('查询折扣失败', error)
        item.discountPrice = 0
      })
    },
    dateFormat(date) {
      if (!date) return ''
      return formatDate(date)
    },
    formatPrice(price) {
      if (!price && price !== 0) return '-'
      return String(price).split('/')[0]
    },
    trimRoomName(name) {
      if (!name) return ''
      const match = name.match(/(\d+[号楼栋幢].*)$/)
      return match ? match[1] : name
    },
    changeNumMoneyToChinese,
    handlePrint() {
      // 打印前刷新时间，确保与实际打印时刻一致
      this.printPayFeeInfo.printTime = getDateStr()
      this.$nextTick(() => {
        document.getElementById('print-btn').style.display = 'none'
        window.print()
        window.opener = null
        window.close()
      })
    },
    handleClose() {
      window.opener = null
      window.close()
    }
  }
}
</script>

<style>
.print-pay-fee-beilin-container {
  width: 241mm;
  min-height: 140mm;
  margin: 0 auto;
  padding: 8mm;
  box-sizing: border-box;
  color: #000;
  font-family: 'SimSun', '宋体', serif;
  font-size: 15px;
  background: #fff;
}

.receipt-title {
  text-align: center;
  font-size: 26px;
  font-weight: bold;
  letter-spacing: 3px;
  margin-bottom: 16px;
}

.receipt-header {
  margin-bottom: 12px;
}

.header-row {
  display: flex;
  justify-content: space-between;
  line-height: 26px;
  margin-bottom: 4px;
}

.header-row:last-child {
  margin-bottom: 0;
}

.receipt-num-row {
  justify-content: flex-end;
}

.header-item {
  flex: 1;
  display: flex;
  align-items: baseline;
}

.header-item.center {
  justify-content: center;
}

.header-item.right {
  justify-content: flex-end;
}

.header-item .label {
  flex-shrink: 0;
}

.header-item .value {
  display: inline-block;
  min-width: 60px;
  border-bottom: 1px solid #000;
  padding: 0 6px;
  text-align: center;
  max-width: 220px;
  word-break: break-all;
  white-space: normal;
}

.text-right {
  text-align: right;
}

.fee-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 10px;
  font-size: 15px;
}

.fee-table th,
.fee-table td {
  border: 1px solid #000;
  padding: 5px 3px;
  text-align: center;
  vertical-align: middle;
}

.fee-table th {
  font-weight: bold;
  background: #f5f5f5;
}

.amount-row {
  display: flex;
  align-items: baseline;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  line-height: 26px;
}

.amount-row .value {
  display: inline-block;
  min-width: 100px;
  border-bottom: 1px solid #000;
  margin: 0 8px;
  text-align: center;
  flex: 1;
}

.receipt-footer {
  margin-top: 20px;
}

.footer-row {
  display: flex;
  justify-content: space-between;
  line-height: 26px;
  margin-bottom: 4px;
}

.footer-item {
  flex: 1;
  display: flex;
  align-items: baseline;
}

.footer-item.right {
  justify-content: flex-end;
}

.footer-item .value {
  padding: 0 4px;
}

.footer-note {
  text-align: left;
  font-size: 14px;
  line-height: 22px;
  margin-top: 8px;
}

@media print {
  #print-btn {
    display: none !important;
  }

  .print-pay-fee-beilin-container {
    padding: 5mm;
  }
}
</style>
